// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoContainer_root__1J1VK"};